import { render } from "./SurveyBuilderGopsi.vue?vue&type=template&id=5dfbb2d8&scoped=true"
import script from "./SurveyBuilderGopsi.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderGopsi.vue?vue&type=script&lang=js"

import "./SurveyBuilderGopsi.vue?vue&type=style&index=0&id=5dfbb2d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfbb2d8"]])

export default __exports__